module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": "",
      "wrap": "",
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('br'), _c('br'), _vm._v(" "), _c('h2', [_vm._v("Página Inicial")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/consulta-projetos",
      "tag": "button"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "large": ""
    }
  }, [_vm._v("Consulta")])], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/ajuda",
      "tag": "button"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "large": ""
    }
  }, [_vm._v("Ajuda")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6441ea44","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ajuda/inicio.vue
// module id = 352
// module chunks = 0